import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500">编辑精选优质漫画，这个假期不愁没得看</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {cardsData.map((card) => (
            <div
              key={card.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.cover}
                  alt={card.title}
                  className="w-full aspect-[3/4] object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${
                    card.status === '连载中'
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {card.status}
                  </span>
                </div>
                {card.update && (
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-900/80 to-transparent px-3 py-4">
                    <span className="text-xs text-background-100 font-medium">{card.update}</span>
                  </div>
                )}
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading font-bold text-foreground-900 text-sm md:text-base mb-1 truncate">
                  {card.title}
                </h3>
                <span className="inline-block text-[10px] md:text-xs text-primary-600 font-medium mb-2">
                  {card.tag}
                </span>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}